



































































































































































































import VueOptions from '@utils/VueOptions'
import CalendarService from '@services/CalendarService'

settings =
  name: 'VenueDisplay'

  resources:
    dates:
      resourceName: 'calendar_date'
      slug: 'suppliers/:supplierId/venues/:venue.id/calendar_dates'
      params:
        quick_list: true

  vue:
    props: ['venue', 'options']

    computed:
      supplierId: -> @options?.supplierId || @$store.member.supplier.id

      location: ->
        return @$options.filters.formatLocation(@venue) if @venue.venue_class isnt 'venue'
        address = [@venue.street, @venue.city, @venue.state, @venue.country, @venue.zip]
        @compact(address).join(', ')

      mapStorageIconClass: ->
        standard_storage_available: 'fas fa-boxes'
        climate_controlled_storage_available: 'fas fa-air-conditioner'
        cold_storage_available: 'fas fa-wind'
        frozen_storage_available: 'fas fa-snowflake'

      venueDates: ->
        return [] unless @dates
        dates = JSON.parse(JSON.stringify(@dates))
        dates.map((date) ->
          date.rrule = CalendarService.rruleFromString(date.rrule_string) if date.repeats
          date
        )

      venueDatesTableData: ->
        @venueDates.map((date) =>
          { starts_on, repeats, rrule_string: rruleString } = date
          id: date.id
          data: date
          experience: date.creative_title
          date: CalendarService.formatCalendarDate({ date: starts_on, repeats, rruleString })
        )

      catexTableData: ->
        { formatTitle } = @$options.filters
        for key, catex of @venue.catex
          continue if catex.prohibited
          category: formatTitle(catex.category)
          sponsors: catex.sponsors

      prohibitedCategories: ->
        for key, catex of @venue.catex
          continue unless catex.prohibited
          catex.category

      seasonsTableData: ->
        (@venue.seasons || []).map((season) =>
          year = dayjs().get('year')
          id: season.id
          data: season
          name: season.name
          starts_on: dayjs("#{year}-#{season.start_month}-#{season.start_day}").format('MMM DD')
          ends_on: dayjs("#{year}-#{season.end_month}-#{season.end_day}").format('MMM DD')
        )

      blockoutDatesTableData: ->
        (@venue.blockout_dates || []).map((date) =>
          id: date.id
          data: date
          name: date.name
          starts_on: dayjs(date.starts_on).format('MMM DD, YYYY')
          ends_on: dayjs(date.ends_on).format('MMM DD, YYYY')
        )

export default VueOptions.vue settings
